import { render, staticRenderFns } from "./Standing.vue?vue&type=template&id=6596579a&scoped=true&"
import script from "./Standing.vue?vue&type=script&lang=js&"
export * from "./Standing.vue?vue&type=script&lang=js&"
import style0 from "./Standing.vue?vue&type=style&index=0&id=6596579a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6596579a",
  null
  
)

export default component.exports